import { render, staticRenderFns } from "./proc.vue?vue&type=template&id=f6b47170&scoped=true"
import script from "./proc.vue?vue&type=script&lang=js"
export * from "./proc.vue?vue&type=script&lang=js"
import style0 from "./proc.vue?vue&type=style&index=0&id=f6b47170&prod&scoped=true&lang=css"
import style1 from "./proc.vue?vue&type=style&index=1&id=f6b47170&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b47170",
  null
  
)

export default component.exports